export default __webpack_public_path__ + "static/media/fb.f4b898ab.svg";